const ROLES_OBJECT = {
  AGENCY_USER: "Planning",
  AGENCY_SUPER_OPERATOR: "Resourcing",
  FINANCE_USER: "Finance",
  AGENCY_ADMIN: "Admin",
  SYSTEM_ADMIN: "System Admin",
  CLIENT_USER: "Client",
  CLIENT_TIME_SHEET: "ClientTimesheet",
  CLIENT_FINANCE_USER: "ClientFinance"
};

const ROLES = Object.freeze(ROLES_OBJECT);

export default ROLES;
